export const iconFontAwesomeDisasterCrisisTemperatureArrowDown = (
	<i className="fa-solid fa-temperature-arrow-down"></i>
);
